import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import messages from './messages';

const Message = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallBold};
  text-align: center;
  color: ${({ theme }) => theme.colors.night_blue_1};
  background: ${({ theme }) => theme.colors.atomic_tangerine};
  padding: ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => theme.spacing(3, 3, 0, 0)};
  text-transform: uppercase;
`;

function Closed({ className, closedLabel }) {
  if (closedLabel) {
    return <Message className={className}>{closedLabel}</Message>;
  }

  return (
    <FormattedMessage {...messages.closed}>
      {message => <Message className={className}>{message}</Message>}
    </FormattedMessage>
  );
}

Closed.propTypes = {
  className: PropTypes.string,
  closedLabel: PropTypes.string,
};

export default Closed;
